/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSetting_1 } from '../fn/facility-group-notification-setting/add-setting-1';
import { AddSetting_1$Params } from '../fn/facility-group-notification-setting/add-setting-1';
import { deleteSetting_1 } from '../fn/facility-group-notification-setting/delete-setting-1';
import { DeleteSetting_1$Params } from '../fn/facility-group-notification-setting/delete-setting-1';
import { FacilityGroupNotificationSetting } from '../models/facility-group-notification-setting';
import { findByFacilityGroupId } from '../fn/facility-group-notification-setting/find-by-facility-group-id';
import { FindByFacilityGroupId$Params } from '../fn/facility-group-notification-setting/find-by-facility-group-id';
import { getList_1 } from '../fn/facility-group-notification-setting/get-list-1';
import { GetList_1$Params } from '../fn/facility-group-notification-setting/get-list-1';
import { getSetting_1 } from '../fn/facility-group-notification-setting/get-setting-1';
import { GetSetting_1$Params } from '../fn/facility-group-notification-setting/get-setting-1';
import { getSetting_2 } from '../fn/facility-group-notification-setting/get-setting-2';
import { GetSetting_2$Params } from '../fn/facility-group-notification-setting/get-setting-2';
import { updateSetting_3 } from '../fn/facility-group-notification-setting/update-setting-3';
import { UpdateSetting_3$Params } from '../fn/facility-group-notification-setting/update-setting-3';

@Injectable({ providedIn: 'root' })
export class FacilityGroupNotificationSettingService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getList_1()` */
  static readonly GetList_1Path = '/api/facilityGroup/notification/setting';

  /**
   * Get List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_1$Response(params?: GetList_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupNotificationSetting>>> {
    return getList_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_1(params?: GetList_1$Params, context?: HttpContext): Observable<Array<FacilityGroupNotificationSetting>> {
    return this.getList_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityGroupNotificationSetting>>): Array<FacilityGroupNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `addSetting_1()` */
  static readonly AddSetting_1Path = '/api/facilityGroup/notification/setting';

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSetting_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_1$Response(params: AddSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
    return addSetting_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSetting_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_1(params: AddSetting_1$Params, context?: HttpContext): Observable<FacilityGroupNotificationSetting> {
    return this.addSetting_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupNotificationSetting>): FacilityGroupNotificationSetting => r.body)
    );
  }

  /** Path part for operation `findByFacilityGroupId()` */
  static readonly FindByFacilityGroupIdPath = '/api/facilityGroup/notification/setting/facilityGroupId/{facilityGroupId}';

  /**
   * Find By Facility Group Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByFacilityGroupId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByFacilityGroupId$Response(params: FindByFacilityGroupId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupNotificationSetting>>> {
    return findByFacilityGroupId(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Facility Group Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByFacilityGroupId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByFacilityGroupId(params: FindByFacilityGroupId$Params, context?: HttpContext): Observable<Array<FacilityGroupNotificationSetting>> {
    return this.findByFacilityGroupId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityGroupNotificationSetting>>): Array<FacilityGroupNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `getSetting_1()` */
  static readonly GetSetting_1Path = '/api/facilityGroup/notification/setting/id/{settingId}';

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetting_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_1$Response(params: GetSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
    return getSetting_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetting_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_1(params: GetSetting_1$Params, context?: HttpContext): Observable<FacilityGroupNotificationSetting> {
    return this.getSetting_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupNotificationSetting>): FacilityGroupNotificationSetting => r.body)
    );
  }

  /** Path part for operation `getSetting_2()` */
  static readonly GetSetting_2Path = '/api/facilityGroup/notification/setting/title/{title}/type/{type}/facilityGroupId/{facilityGroupId}';

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetting_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_2$Response(params: GetSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
    return getSetting_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetting_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_2(params: GetSetting_2$Params, context?: HttpContext): Observable<FacilityGroupNotificationSetting> {
    return this.getSetting_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupNotificationSetting>): FacilityGroupNotificationSetting => r.body)
    );
  }

  /** Path part for operation `updateSetting_3()` */
  static readonly UpdateSetting_3Path = '/api/facilityGroup/notification/setting/{settingId}';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting_3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_3$Response(params: UpdateSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
    return updateSetting_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting_3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_3(params: UpdateSetting_3$Params, context?: HttpContext): Observable<FacilityGroupNotificationSetting> {
    return this.updateSetting_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupNotificationSetting>): FacilityGroupNotificationSetting => r.body)
    );
  }

  /** Path part for operation `deleteSetting_1()` */
  static readonly DeleteSetting_1Path = '/api/facilityGroup/notification/setting/{settingId}';

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetting_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_1$Response(params: DeleteSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
    return deleteSetting_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetting_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_1(params: DeleteSetting_1$Params, context?: HttpContext): Observable<FacilityGroupNotificationSetting> {
    return this.deleteSetting_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityGroupNotificationSetting>): FacilityGroupNotificationSetting => r.body)
    );
  }

}
